module.exports = __webpack_public_path__ + "web/img/logintext-en.266f55e6.png";